import React, { useMemo } from 'react';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import ProductTemplateSidebar from 'components/common/rfq/ProductTemplateSidebar';
import { PRODUCT_TEMPLATE_CARD_DATA } from 'global/checklists-helpers/ProductTemplateChecklistHelper';
import RFQSaveProductTemplate from 'components/rfq/product-template/rfq-save-product-template';
import RFQChecklistOptionHeader from 'components/common/headers/RFQChecklistOptionHeader';
import RFQSaveProductPageStore, { PageStoreContext } from 'store/pages/rfq/rfq-template/save-product/pageStore';
import useRfqTemplate from 'global/hooks/useRfqTemplate';
import { useHistory } from 'react-router-dom';
import { createStyles } from '../../../../globalStyles';

const RFQSaveProductTemplatePage = (): JSX.Element => {
  const classes = createStyles();

  // Remove this mapping after migration to the react-router v6
  const history = useHistory();

  const { templateId, pageType } = useRfqTemplate();

  const pageStore = useMemo(() => new RFQSaveProductPageStore(), []);

  if (!templateId) return <></>;

  const returnBack = (): void => {
    history.push(`/product-template-checklist/${templateId}?type=${pageType}`);
  };

  return (
    <GlobalLayout
      leftSection={<ProductTemplateSidebar />}
      rightSection={
        <div className={classes.pageWrapper}>
          <RFQChecklistOptionHeader
            title={PRODUCT_TEMPLATE_CARD_DATA.SAVE_PRODUCT_TEMPLATE.title}
            subtitle={PRODUCT_TEMPLATE_CARD_DATA.SAVE_PRODUCT_TEMPLATE.text}
            onRedirectBack={returnBack}
          />
          <PageStoreContext.Provider value={pageStore}>
            <RFQSaveProductTemplate />
          </PageStoreContext.Provider>
        </div>
      }
    />
  );
};

export default RFQSaveProductTemplatePage;
